import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { LocationMapSvg } from 'src/assets/index';
import { IHotelDetails } from 'src/common-types/index';
import { HotelStars } from 'src/components/components/index';
import { getFullAddress } from 'src/utils/index';
import './style.scss';

interface IProps {
  hotel: IHotelDetails;
  showBigMap: () => void;
}

const zero = 0;

class HotelInfoComponent extends React.Component<IProps, null> {
  render(): React.ReactNode {
    const { showBigMap } = this.props;
    const { title, address, starRating, city, countryCode, state, zipCode } = this.props.hotel;
    const fullAddress = getFullAddress(address, city, state, zipCode, countryCode);
    const addressStr = fullAddress.join(', ');

    return (
      <div className="hotel-info">
        <div className="hotel-info__item">
          <h4 className="hotel-info__title">{title} </h4>
          <div className="hotel-info__stars">
            <HotelStars stars={starRating} />
          </div>
          <div className="hotel-info__address-wrapper">
            <p className="hotel-info__address">
              {fullAddress.length !== zero ? addressStr : address}
              <a className="hotel-info__link-text" onClick={showBigMap}>
                <LocationMapSvg />
                <span className="hotel-card-wrapper__link-text">
                  <FormattedMessage id="view.map" />
                </span>
              </a>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export const HotelInfo = connect(null)(HotelInfoComponent);

